import styles from './eventosprivados.module.css'
import YouTube from 'react-youtube'

function Eventos() {
    return (
        <div id='eventosprivados' className={styles.clasesMain}>
            
            {/* --- HEADER --- */}
            <div className={styles.header}>
                <h3>CONCERTS - PRIVATE EVENTS</h3>
                <p>Live tango music for private and corporate events</p>
            </div>

            {/* --- SECCIÓN 1: INTRODUCCIÓN Y PROPUESTA --- */}
            <div className={styles.introContainer}>
                
                {/* Texto Principal */}
                <div className={styles.introTexto}>
                    <p>
                        We offer customized tango shows for private and corporate events, 
                        adapted to the type of celebration, the venue, and the atmosphere you wish to create.
                    </p>
                    <p>
                        We take care of the overall coordination so you only need to choose the format and enjoy the event.
                    </p>
                </div>

                {/*  Lista de Beneficios (La Propuesta)  */}
                <div className={styles.propuestaBox}>
                    <h4 className={styles.subtitulo}>
                        {/* Ícono de Nota Musical (SVG Nativo) */}
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            width="24" height="24" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round" 
                            className={styles.iconoTitulo}
                        >
                            <circle cx="6" cy="18" r="3"></circle>
                            <circle cx="18" cy="16" r="3"></circle>
                            <path d="M9 18V5l12-2v13"></path>
                        </svg>
                        A simple and personalized proposal
                    </h4>
                    
                    <ul className={styles.listaBeneficios}>
                        {[
                            "Tailor-made tango shows",
                            "Repertoire chosen together with the client",
                            "Different musical formats available",
                            "Optional professional tango dancers",
                            "Personal guidance and direct communication"
                        ].map((item, index) => (
                            <li key={index}>
                                {/* Ícono de Check (SVG Nativo) */}
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    width="18" height="18" 
                                    viewBox="0 0 24 24" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    strokeWidth="3" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round" 
                                    className={styles.iconoCheck}
                                >
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                                {item}
                            </li>
                        ))}
                    </ul>
                    <p className={styles.fraseCierre}>
                        "Each event is unique. Every show is specially designed for you."
                    </p>
{/* --- SECCIÓN 2: FORMATOS DISPONIBLES --- */}
            
            {/* Margen grande para separar del cuadro de arriba */}
            <div className={styles.seccionFormatos}>
            <div className={styles.header}>
                <h3>AVAILABLE FORMATS</h3>
                <p>Choose the ideal setup for your event</p>
            </div>

            <div className={styles.clasesContainer}>
                
                {/* TARJETA 1: Show Solista */}
                <div className={styles.box}>
                    <div className={styles.boxContent}>
                        <h4 className={styles.tituloClase}>Solo performance</h4>
                        <p className={styles.descripcionClase}>
                            Solo voice with high-quality backing tracks.
                            Ideal for intimate gatherings and private celebrations.
                        </p>
                    </div>
                </div>

                {/* TARJETA 2: Dúo */}
                <div className={styles.box}>
                    <div className={styles.boxContent}>
                        <h4 className={styles.tituloClase}>Duo</h4>
                        <p className={styles.descripcionClase}>
                            Voice plus an accompanying musician, always of top professional level.
                            A perfect balance between intimacy and musical presence.
                        </p>
                    </div>
                </div>

                {/* TARJETA 3: Cuarteto */}
                <div className={styles.box}>
                    <div className={styles.boxContent}>
                        <h4 className={styles.tituloClase}>Quartet</h4>
                        <p className={styles.descripcionClase}>
                            Full instrumental formation, offering greater musical richness.
                        </p>
                    </div>
                </div>

                {/* TARJETA 4: Orquesta */}
                <div className={styles.box}>
                    <div className={styles.boxContent}>
                        <h4 className={styles.tituloClase}>Orchestra</h4>
                        <p className={styles.descripcionClase}>
                            A high-level artistic proposal for special occasions and corporate events.
                        </p>
                    </div>
                </div>

            </div>

            {/* --- OPCIÓN EXTRA: BAILE (TEXTO SIMPLE) --- */}
                <div className={styles.baileContainer}>
                    <p className={styles.baileTexto}>
                        <span className={styles.baileTitulo}>
                            {/* Icono de Zapatos pequeño y sutil */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                <circle cx="8.5" cy="7" r="4"></circle>
                                <polyline points="17 11 19 13 23 9"></polyline>
                            </svg>
                            Optional Tango dance
                        </span>
                        A professional tango dance couple can be added, seamlessly integrated into the musical performance for a complete visual experience.
                    </p>
                </div>
                </div>
            </div>
{/* --- SECCIÓN 3: LISTA DE EVENTOS Y CIERRE --- */}
            <div className={styles.finalSection}>

                <ul className={styles.eventosLista}>
                    {/* Mapeamos los items para que el código quede limpio */}
                    {[
                        "Birthdays", 
                        "Anniversaries", 
                        "Weddings", 
                        "Corporate events", 
                        "Private celebrations"
                    ].map((item, index) => (
                        <li key={index} className={styles.eventoItem}>
                            {/* Check simple SVG */}
                            <svg className={styles.checkFinal} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                            {item}
                        </li>
                    ))}
                </ul>
                <div className={styles.videoWrapper}>
                    <YouTube 
                        videoId="WFLACu4VxtY" // <--- CAMBIAR ESTO
                        className={styles.reproductor}
                        opts={{
                            width: '100%',
                            height: '100%',
                            playerVars: {
                                autoplay: 0,
                                showinfo: 0,
                                rel: 0, // Evita videos relacionados de otros canales
                            },
                        }}
                    />
                </div>
                <div className={styles.ctaContainer}>
                    <p className={styles.ctaTexto}>
                        "Each event is prepared in a personalized way.
                        Contact us to create a proposal tailored to your event and preferences.""

                    </p>
                    
                    {/* El botón de acción */}
                    <a href="https://wa.me/2215586164" className={styles.botonCTA}>
                        Chat in WhatsApp
                    </a>
                </div>

            </div>
                </div>
            </div>
        
    )
}

export default Eventos 